import React from "react";
import SubHeader from "../header/SubHeader";
import { Tabs } from "antd";
import "./layout.less";
const { TabPane } = Tabs;
const PageContent = ({
  subheader = false,
  children,
  type = null,
  tabPanes = [],
  onTabChange = () => undefined,
  tabBackground = "transparent",
  background = "#F4F4F6",
}) => {
  return (
    <div className="page-container">
      {typeof subheader === "object" && (
        <SubHeader
          title={subheader.title ?? "-"}
          background={subheader.background}
        >
          {subheader.content ?? null}
        </SubHeader>
      )}
      {type === "tab" && (
        <Tabs
          className="page-content-tab"
          style={{ backgroundColor: tabBackground }}
          onChange={onTabChange}
        >
          {tabPanes.map((tabPane) => {
            return <TabPane key={tabPane.value} tab={tabPane.title} />;
          })}
        </Tabs>
      )}
      <div
        className="page-content-container"
        style={{ backgroundColor: background, margin: 0 }}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContent;
